// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/home-regional-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scoped to .epw-home instead of html/body/* so this page's styling
   doesn't leak into the rest of the app (dashboard, sidebar, etc.). */
.epw-home, .epw-home *{box-sizing:border-box}

.epw-home{width:100%;font-family:Arial,Helvetica,sans-serif;}

.epw-simple-hero{
  position:relative;
  color:#fff;
  min-height:calc(100vh - 77px - 62px);
  padding:36px clamp(24px,4.3vw,72px);
  overflow:hidden;
  display:grid;
  grid-template-columns:minmax(0,1.25fr) minmax(355px,.75fr);
  gap:34px;
  align-items:center;
  background:
    linear-gradient(180deg,rgba(9,21,48,.12) 0%,rgba(10,27,64,.34) 45%,rgba(13,48,112,.74) 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat;
}
.epw-simple-hero::after{
  content:"";
  position:absolute;
  inset:0;
  pointer-events:none;
  background:linear-gradient(90deg,rgba(2,17,42,.18),transparent 40%,rgba(2,17,42,.08));
}

.epw-main-column,
.epw-topic-column{
  position:relative;
  z-index:2;
}

.epw-main-column{
  width:min(900px,100%);
  justify-self:center;
}

.epw-hero-intro{
  max-width:820px;
}
.epw-hero-intro h1{
  margin:0;
  font-family:"Arial Narrow","Roboto Condensed","Helvetica Neue",Arial,sans-serif;
  font-size:clamp(2.25rem,4.25vw,4.15rem);
  line-height:1.02;
  letter-spacing:-.025em;
  font-weight:800;
  text-shadow:0 2px 10px rgba(0,0,0,.18);
}

/* Collapsed-state explanatory copy */
.epw-overview-copy{
  max-width:700px;
  margin-top:38px;
  padding:24px 26px;
  border:1px solid rgba(255,255,255,.22);
  border-radius:18px;
  background:rgba(7,25,60,.34);
  backdrop-filter:blur(5px);
  -webkit-backdrop-filter:blur(5px);
  transition:opacity .24s ease,transform .28s ease,max-height .35s ease,padding .35s ease,margin .35s ease;
}
.epw-overview-copy h2{
  margin:0 0 10px;
  font-size:clamp(1.35rem,2vw,2rem);
}
.epw-overview-copy p{
  margin:0;
  max-width:660px;
  color:rgba(255,255,255,.91);
  line-height:1.55;
}
.epw-simple-hero.is-expanded .epw-overview-copy{
  opacity:0;
  transform:translateY(6px);
  max-height:0;
  overflow:hidden;
  padding-top:0;
  padding-bottom:0;
  margin-top:0;
  border-width:0;
}

/* Expanded content appears in the left column, not below the buttons. */
.epw-detail-panel{
  max-width:790px;
  max-height:0;
  opacity:0;
  overflow:hidden;
  margin-top:0;
  padding:0 26px;
  transform:translateY(-8px);
  border:0 solid rgba(255,255,255,.24);
  border-radius:20px;
  background:rgba(8,27,65,.54);
  backdrop-filter:blur(8px);
  -webkit-backdrop-filter:blur(8px);
  box-shadow:0 18px 55px rgba(0,0,0,.14);
  transition:
    max-height .4s cubic-bezier(.22,.61,.36,1),
    opacity .25s ease,
    transform .34s ease,
    margin .34s ease,
    padding .34s ease,
    border-width .34s ease;
}
.epw-simple-hero.is-expanded .epw-detail-panel{
  max-height:390px;
  opacity:1;
  margin-top:32px;
  padding:25px 28px 27px;
  transform:translateY(0);
  border-width:1px;
}
.epw-detail-heading{
  display:flex;
  align-items:center;
  gap:17px;
}
.epw-detail-heading img{
  width:64px;
  height:64px;
  flex:none;
}
.epw-detail-kicker{
  margin:0 0 4px;
  font-size:.76rem;
  font-weight:800;
  letter-spacing:.11em;
  text-transform:uppercase;
  color:rgba(255,255,255,.72);
}
.epw-detail-heading h2{
  margin:0;
  font-size:clamp(1.65rem,2.55vw,2.35rem);
  line-height:1.1;
}
.epw-detail-copy{
  margin:17px 0 20px;
  max-width:730px;
  font-size:clamp(.98rem,1.25vw,1.12rem);
  line-height:1.55;
  color:rgba(255,255,255,.94);
}
.epw-detail-link{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  min-height:45px;
  padding:0 23px;
  border-radius:999px;
  background:rgba(255,255,255,.94);
  color:#173567;
  text-decoration:none;
  font-weight:800;
}
.epw-detail-link:hover,.epw-detail-link:focus-visible{
  background:#fff;
  outline:3px solid rgba(255,255,255,.35);
  outline-offset:2px;
}

/* Right-side vertical topic column */
.epw-topic-column{
  width:100%;
  max-width:470px;
  justify-self:end;
  display:flex;
  flex-direction:column;
  gap:12px;
}
.epw-topic{
  width:100%;
  min-height:94px;
  border:1px solid rgba(255,255,255,.22);
  border-radius:17px;
  padding:13px 16px;
  background:rgba(6,23,52,.45);
  color:#fff;
  cursor:pointer;
  display:flex;
  align-items:center;
  gap:14px;
  text-align:left;
  font:inherit;
  backdrop-filter:blur(5px);
  -webkit-backdrop-filter:blur(5px);
  transition:transform .2s ease,background .2s ease,border-color .2s ease,box-shadow .2s ease;
}
.epw-topic:hover{
  transform:translateX(-3px);
  background:rgba(6,23,52,.62);
  border-color:rgba(255,255,255,.42);
}
.epw-topic:focus-visible{
  outline:3px solid #fff;
  outline-offset:3px;
}
.epw-topic[aria-expanded="true"]{
  background:rgba(255,255,255,.17);
  border-color:rgba(255,255,255,.78);
  box-shadow:0 10px 30px rgba(0,0,0,.14);
}
.epw-topic img{
  width:58px;
  height:58px;
  flex:none;
}
.epw-topic-text{
  display:flex;
  flex-direction:column;
  gap:4px;
}
.epw-topic-text strong{
  font-size:clamp(1rem,1.25vw,1.22rem);
  line-height:1.15;
}
.epw-topic-text small{
  font-size:.82rem;
  line-height:1.25;
  color:rgba(255,255,255,.72);
}
.epw-toggle-hint{
  margin:2px 4px 0;
  font-size:.78rem;
  color:rgba(255,255,255,.70);
  text-align:right;
}

@media(max-width:980px){
  .epw-simple-hero{
    min-height:auto;
    grid-template-columns:1fr;
    gap:28px;
    padding-top:34px;
    padding-bottom:34px;
  }
  .epw-main-column{justify-self:stretch}
  .epw-topic-column{
    max-width:none;
    display:grid;
    grid-template-columns:repeat(2,minmax(0,1fr));
  }
  .epw-toggle-hint{
    grid-column:1/-1;
    text-align:center;
  }
}
@media(max-width:620px){
  .epw-simple-hero{
    padding:30px 16px;
  }
  .epw-topic-column{
    grid-template-columns:1fr;
  }
  .epw-topic{min-height:88px}
  .epw-topic img{width:52px;height:52px}
  .epw-simple-hero.is-expanded .epw-detail-panel{
    max-height:520px;
    padding:20px;
  }
  .epw-detail-heading img{width:54px;height:54px}
}
@media(prefers-reduced-motion:reduce){
  .epw-overview-copy,.epw-detail-panel,.epw-topic{transition:none}
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA;sEACsE;AACtE,uBAAuB,qBAAqB;;AAE5C,UAAU,UAAU,CAAC,sCAAsC,CAAC;;AAE5D;EACE,iBAAiB;EACjB,UAAU;EACV,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,0DAA0D;EAC1D,QAAQ;EACR,kBAAkB;EAClB;;kEAE2E;AAC7E;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,mBAAmB;EACnB,qFAAqF;AACvF;;AAEA;;EAEE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,QAAQ;EACR,+EAA+E;EAC/E,uCAAuC;EACvC,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,iCAAiC;EACjC,wGAAwG;AAC1G;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,eAAe;EACf,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,iCAAiC;EACjC,sCAAsC;EACtC;;;;;;0BAMwB;AAC1B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,QAAQ;EACR,uCAAuC;EACvC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,eAAe;EACf,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,UAAU;EACV,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,UAAU;EACV,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,2FAA2F;AAC7F;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,OAAO;AACT;AACA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;EACrB;EACA,iBAAiB,oBAAoB;EACrC;IACE,cAAc;IACd,YAAY;IACZ,6CAA6C;EAC/C;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA,WAAW,eAAe;EAC1B,eAAe,UAAU,CAAC,WAAW;EACrC;IACE,gBAAgB;IAChB,YAAY;EACd;EACA,wBAAwB,UAAU,CAAC,WAAW;AAChD;AACA;EACE,gDAAgD,eAAe;AACjE","sourcesContent":["/* Scoped to .epw-home instead of html/body/* so this page's styling\n   doesn't leak into the rest of the app (dashboard, sidebar, etc.). */\n.epw-home, .epw-home *{box-sizing:border-box}\n\n.epw-home{width:100%;font-family:Arial,Helvetica,sans-serif;}\n\n.epw-simple-hero{\n  position:relative;\n  color:#fff;\n  min-height:calc(100vh - 77px - 62px);\n  padding:36px clamp(24px,4.3vw,72px);\n  overflow:hidden;\n  display:grid;\n  grid-template-columns:minmax(0,1.25fr) minmax(355px,.75fr);\n  gap:34px;\n  align-items:center;\n  background:\n    linear-gradient(180deg,rgba(9,21,48,.12) 0%,rgba(10,27,64,.34) 45%,rgba(13,48,112,.74) 100%),\n    url(\"/public/assets/home-regional-background.jpg\") center/cover no-repeat;\n}\n.epw-simple-hero::after{\n  content:\"\";\n  position:absolute;\n  inset:0;\n  pointer-events:none;\n  background:linear-gradient(90deg,rgba(2,17,42,.18),transparent 40%,rgba(2,17,42,.08));\n}\n\n.epw-main-column,\n.epw-topic-column{\n  position:relative;\n  z-index:2;\n}\n\n.epw-main-column{\n  width:min(900px,100%);\n  justify-self:center;\n}\n\n.epw-hero-intro{\n  max-width:820px;\n}\n.epw-hero-intro h1{\n  margin:0;\n  font-family:\"Arial Narrow\",\"Roboto Condensed\",\"Helvetica Neue\",Arial,sans-serif;\n  font-size:clamp(2.25rem,4.25vw,4.15rem);\n  line-height:1.02;\n  letter-spacing:-.025em;\n  font-weight:800;\n  text-shadow:0 2px 10px rgba(0,0,0,.18);\n}\n\n/* Collapsed-state explanatory copy */\n.epw-overview-copy{\n  max-width:700px;\n  margin-top:38px;\n  padding:24px 26px;\n  border:1px solid rgba(255,255,255,.22);\n  border-radius:18px;\n  background:rgba(7,25,60,.34);\n  backdrop-filter:blur(5px);\n  -webkit-backdrop-filter:blur(5px);\n  transition:opacity .24s ease,transform .28s ease,max-height .35s ease,padding .35s ease,margin .35s ease;\n}\n.epw-overview-copy h2{\n  margin:0 0 10px;\n  font-size:clamp(1.35rem,2vw,2rem);\n}\n.epw-overview-copy p{\n  margin:0;\n  max-width:660px;\n  color:rgba(255,255,255,.91);\n  line-height:1.55;\n}\n.epw-simple-hero.is-expanded .epw-overview-copy{\n  opacity:0;\n  transform:translateY(6px);\n  max-height:0;\n  overflow:hidden;\n  padding-top:0;\n  padding-bottom:0;\n  margin-top:0;\n  border-width:0;\n}\n\n/* Expanded content appears in the left column, not below the buttons. */\n.epw-detail-panel{\n  max-width:790px;\n  max-height:0;\n  opacity:0;\n  overflow:hidden;\n  margin-top:0;\n  padding:0 26px;\n  transform:translateY(-8px);\n  border:0 solid rgba(255,255,255,.24);\n  border-radius:20px;\n  background:rgba(8,27,65,.54);\n  backdrop-filter:blur(8px);\n  -webkit-backdrop-filter:blur(8px);\n  box-shadow:0 18px 55px rgba(0,0,0,.14);\n  transition:\n    max-height .4s cubic-bezier(.22,.61,.36,1),\n    opacity .25s ease,\n    transform .34s ease,\n    margin .34s ease,\n    padding .34s ease,\n    border-width .34s ease;\n}\n.epw-simple-hero.is-expanded .epw-detail-panel{\n  max-height:390px;\n  opacity:1;\n  margin-top:32px;\n  padding:25px 28px 27px;\n  transform:translateY(0);\n  border-width:1px;\n}\n.epw-detail-heading{\n  display:flex;\n  align-items:center;\n  gap:17px;\n}\n.epw-detail-heading img{\n  width:64px;\n  height:64px;\n  flex:none;\n}\n.epw-detail-kicker{\n  margin:0 0 4px;\n  font-size:.76rem;\n  font-weight:800;\n  letter-spacing:.11em;\n  text-transform:uppercase;\n  color:rgba(255,255,255,.72);\n}\n.epw-detail-heading h2{\n  margin:0;\n  font-size:clamp(1.65rem,2.55vw,2.35rem);\n  line-height:1.1;\n}\n.epw-detail-copy{\n  margin:17px 0 20px;\n  max-width:730px;\n  font-size:clamp(.98rem,1.25vw,1.12rem);\n  line-height:1.55;\n  color:rgba(255,255,255,.94);\n}\n.epw-detail-link{\n  display:inline-flex;\n  align-items:center;\n  justify-content:center;\n  min-height:45px;\n  padding:0 23px;\n  border-radius:999px;\n  background:rgba(255,255,255,.94);\n  color:#173567;\n  text-decoration:none;\n  font-weight:800;\n}\n.epw-detail-link:hover,.epw-detail-link:focus-visible{\n  background:#fff;\n  outline:3px solid rgba(255,255,255,.35);\n  outline-offset:2px;\n}\n\n/* Right-side vertical topic column */\n.epw-topic-column{\n  width:100%;\n  max-width:470px;\n  justify-self:end;\n  display:flex;\n  flex-direction:column;\n  gap:12px;\n}\n.epw-topic{\n  width:100%;\n  min-height:94px;\n  border:1px solid rgba(255,255,255,.22);\n  border-radius:17px;\n  padding:13px 16px;\n  background:rgba(6,23,52,.45);\n  color:#fff;\n  cursor:pointer;\n  display:flex;\n  align-items:center;\n  gap:14px;\n  text-align:left;\n  font:inherit;\n  backdrop-filter:blur(5px);\n  -webkit-backdrop-filter:blur(5px);\n  transition:transform .2s ease,background .2s ease,border-color .2s ease,box-shadow .2s ease;\n}\n.epw-topic:hover{\n  transform:translateX(-3px);\n  background:rgba(6,23,52,.62);\n  border-color:rgba(255,255,255,.42);\n}\n.epw-topic:focus-visible{\n  outline:3px solid #fff;\n  outline-offset:3px;\n}\n.epw-topic[aria-expanded=\"true\"]{\n  background:rgba(255,255,255,.17);\n  border-color:rgba(255,255,255,.78);\n  box-shadow:0 10px 30px rgba(0,0,0,.14);\n}\n.epw-topic img{\n  width:58px;\n  height:58px;\n  flex:none;\n}\n.epw-topic-text{\n  display:flex;\n  flex-direction:column;\n  gap:4px;\n}\n.epw-topic-text strong{\n  font-size:clamp(1rem,1.25vw,1.22rem);\n  line-height:1.15;\n}\n.epw-topic-text small{\n  font-size:.82rem;\n  line-height:1.25;\n  color:rgba(255,255,255,.72);\n}\n.epw-toggle-hint{\n  margin:2px 4px 0;\n  font-size:.78rem;\n  color:rgba(255,255,255,.70);\n  text-align:right;\n}\n\n@media(max-width:980px){\n  .epw-simple-hero{\n    min-height:auto;\n    grid-template-columns:1fr;\n    gap:28px;\n    padding-top:34px;\n    padding-bottom:34px;\n  }\n  .epw-main-column{justify-self:stretch}\n  .epw-topic-column{\n    max-width:none;\n    display:grid;\n    grid-template-columns:repeat(2,minmax(0,1fr));\n  }\n  .epw-toggle-hint{\n    grid-column:1/-1;\n    text-align:center;\n  }\n}\n@media(max-width:620px){\n  .epw-simple-hero{\n    padding:30px 16px;\n  }\n  .epw-topic-column{\n    grid-template-columns:1fr;\n  }\n  .epw-topic{min-height:88px}\n  .epw-topic img{width:52px;height:52px}\n  .epw-simple-hero.is-expanded .epw-detail-panel{\n    max-height:520px;\n    padding:20px;\n  }\n  .epw-detail-heading img{width:54px;height:54px}\n}\n@media(prefers-reduced-motion:reduce){\n  .epw-overview-copy,.epw-detail-panel,.epw-topic{transition:none}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
